export default {
    PRODWS_URL: process.env.REACT_APP_PRODWS_AFREESPACE_URL || "https://prodws.afreespace.com",
    LOGIN_BASE_URL: process.env.REACT_APP_LOGIN_BASE_URL || "https://login.afreespace.com",
    PROD_PAM_LINKER_URL: process.env.REACT_APP_PROD_PAM_LINKER_URL || "https://pam-qrlinker.afreespace.com",
    PAM_BASE_URL: process.env.REACT_APP_PAM_BASE_URL || "https://pam.afreespace.com",
    SPOT_BASE_URL: process.env.REACT_APP_SPOT_BASE_URL || "https://spotws.afreespace.com"
}
